var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"cabecera bg-primary"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col barra"},[_c('div',{staticClass:"float-left der-icon"},[_c('img',{staticStyle:{"padding-top":"1rem"},attrs:{"src":require("@/assets/images/Logo-Kia.png"),"alt":"KIA LOGO"}})])])])])])
}]

export { render, staticRenderFns }